import googleMapComponents from "./googleMapComponents";

export default googleMapComponents;